import {useAppContext} from "@/api/app/AppContext"
import {exchangeTokenFailures} from "@/api/app/AppReducer"
import {useTheme} from "@/hooks/useTheme"
import FlexBox from "@/components/layout/FlexBox"
import React, { useState } from "react"
import {Redirect} from "react-router-dom"
import Footer from "@/components/layout/Footer"
import {MobileLayout} from "@/components/layout/MobileLayout"
import StickyButtonContainer from "@/pages/mobile/income/components/layout/containers/StickyButtonContainer"

const styles = {
  input: {
    width: '100%',
    padding: 5,
    border: '1px solid #ddd',
    borderRadius: 4,
    marginBottom: 5,
    outline: 'none',
  }
}

const failureMessages = {
  [exchangeTokenFailures.tokenNotFound]: "We couldn't find that token. Check it matches the one you were sent, including capital letters, and try again.",
  [exchangeTokenFailures.unavailable]: "We couldn't check your token just now. Please try again in a moment."
}

function TokenInput({history}) {
  const params = new URLSearchParams(window.location.search)
  const t = params.get("t")
  const token = params.get("token")
  const {appState, onTokenSubmitted} = useAppContext()
  const theme = useTheme()
  const failureMessage = failureMessages[appState.exchangeTokenFailure]
  const [inputToken, setInputToken] = useState(appState.token || "")

  const handleSubmit = () => {
    if (inputToken) {
      onTokenSubmitted()
      history.push(`/t/${inputToken}`)
    }
  }

  if (t) {
    return <Redirect to={`/t/${t}`}/>
  } else if (token) {
    return <Redirect to={`/t/${token}`}/>
  } else if (appState.token && !appState.exchangeTokenFailure) {
    return <Redirect to={`/t/${appState.token}`}/>
  } else {
    return (
      <MobileLayout footer={<Footer/>}>
        <FlexBox flexGrow marginTop column>
          <h2>Manual Token Input</h2>
          <FlexBox marginTop marginBottom column>
            <FlexBox>
              You've arrived without a token. Please request your unique token from the agent and input below:
            </FlexBox>
          </FlexBox>
          <FlexBox marginTop marginBottom>
          <input
            value={inputToken}
            onChange={(e) => setInputToken(e.target.value)}
            placeholder="Enter your token"
            style={styles.input}
          />
          </FlexBox>
          {failureMessage && (
            <div role="alert" style={theme.inputField.footer.errorText}>
              {failureMessage}
            </div>
          )}
          <StickyButtonContainer
            buttons={[
              {
                text: "Submit Token",
                onClick: handleSubmit,
                disabled: !inputToken
              }
            ]}
          />
        </FlexBox>
      </MobileLayout>
    )
  }
}

export default TokenInput